<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
      @click:outside="$emit('closeHelp', true)"
    >      
      <v-card>
        <v-card-title class="text-h5 green">
          Ranks and limits
        </v-card-title>
        <v-card-text class="pt-3">
            <v-list>
                <div v-for="(limit, i) in limits" :key="i">
                <v-list-item>
                    <v-row align="center">
                        <v-col style="max-width: 80px" class="px-0">
                            <v-tooltip bottom>  
                                <template v-slot:activator="{ on, attrs }">
                                    <img                                
                                        width="70"
                                        v-bind="attrs"
                                        v-on="on"
                                        :src="rankDistribution[limit].image_url"/>                          
                                </template>
                                <span>{{rankDistribution[limit].name}}</span>
                            </v-tooltip>                            
                        </v-col>
                        <v-col  class="px-0" align="right">
                            <span>{{rankDistribution[limit].limit.toFixed()}}</span>
                        </v-col>

                    </v-row>
                </v-list-item>
                <v-divider></v-divider>

                </div>

            </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>                    
          <v-btn
            color="green darken-1"
            text
            @click="$emit('closeHelp', true)"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "RankDialog",
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            rankDistribution: {
                type: Object,
                default: function() {return {}}
            },
            limits: {
                type: Array,
                default: function() {return []}
            }
        },                
    }
</script>

<style lang="scss" scoped>

</style>